import React from "react";
import styled from "styled-components";

const StyledImagesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 425px) {
    flex-direction: column;
  }
`;

const ImageWrapper = styled.div`
  width: ${props => props.width}%;
  @media screen and (max-width: 425px) {
    width: 100%;
  }
`;

const StyledImage = styled.img`
  width: 80%;
  height: 78%;
  margin: 6%;
  margin-top: 6%;
  :hover{
    width: 85%;
    height: 85%;
    margin: 0;
    margin-top: 5%;
  }
`;

const ImageContainer = props => {
  const { images, links } = props;
  return (
    <StyledImagesWrapper>
      <br />
      {images.map((image, i) => {
        return (
          <ImageWrapper
            key={i}
            width={images.length === 0 ? 0 : 100 / 3}
          >
            <a
              href={links[i]}
              target="_blank"
              rel="noopener noreferrer"
            >
              <StyledImage src={image} />
            </a>
          </ImageWrapper>
        );
      })}
    </StyledImagesWrapper>
  );
};

export default ImageContainer;
